/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  Input,
  OnChanges,
  HostListener,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { RoutingService } from 'src/app/service/routing.service';
import { ConfigService } from 'src/app/service/config.service';
import { QueryEditorComponent } from '../../news-query/query-editor/query-editor.component';
import { QueryNameComponent } from '../../news-query/query-name/query-name.component';
import { ReportStateService } from 'src/app/shared/services/report-state.service';
import { AiSearchService } from 'src/app/shared/services/ai-search/ai-search.service';

@Component({
  selector: 'app-query-title',
  templateUrl: './query-title.component.html',
  styleUrls: ['./query-title.component.scss'],
})
export class QueryTitleComponent implements OnChanges {
  @Input() titolo: any;
  @ViewChild('queryMenuTrigger') queryMenuTrigger: MatMenuTrigger;

  isNarrow = window.innerWidth < 1550;
  params: any = {};

  constructor(
    public routing: RoutingService,
    public auth: AuthService,
    public config: ConfigService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    public reportStateService: ReportStateService,
    private aiSearchService: AiSearchService,
  ) {
    this.route.queryParams.subscribe((params) => {
      this.params = params;
    });
  }

  @HostListener('window:resize')
  onResize(): void {
    this.isNarrow = window.innerWidth < 1550;
  }

  get label(): string {
    if (this.routing.isQuery()) {
      return this.params.id === this.params.groupId ? 'Collection' : 'Query';
    }
    return 'Search';
  }

  get name(): string {
    if (this.routing.isQuery()) {
      return this.auth.query?.name ?? '';
    }
    return this.auth.query?.name || this.titolo?.entity?.name || '';
  }

  get collectionQueries(): any[] {
    const { groupId } = this.params;
    if (!groupId) return [];
    const collection = this.auth.querys?.find((c) => c.uid === groupId);
    return collection?.content ?? [];
  }

  openQueryMenu(): void {
    this.queryMenuTrigger?.openMenu();
  }

  navigateToQuery(query: any): void {
    this.router.navigate([], {
      queryParams: {
        id: query.uid,
        groupId: this.params.groupId,
        queryid: null,
        newsfeedFromQuery: null,
      },
      queryParamsHandling: 'merge',
    });
  }

  navigateToCollection(): void {
    this.router.navigate([], {
      queryParams: {
        id: this.params.groupId,
        groupId: this.params.groupId,
        queryid: null,
        newsfeedFromQuery: null,
      },
      queryParamsHandling: 'merge',
    });
  }

  get sentimentDelta(): number {
    return (this.titolo?.sentiment?.sentiment_delta ?? 0) * 100;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['titolo']) {
      const previousValue = changes['titolo'].previousValue;
      const currentValue = changes['titolo'].currentValue;

      // Execute logic if the value has actually changed (including first load)
      if (JSON.stringify(previousValue) !== JSON.stringify(currentValue)) {
        this.executeOnChanges();
      }
    }
  }
  executeOnChanges() {
    if (this.titolo) {
      this.reportStateService.checkStatuses({ mode: 'query' });
    }
  }

  onEdit(): void {
    const authQuery = this.auth.query;
    const isQueryMode = this.routing.isQuery();
    const isSearchMode = this.routing.isSearch();
    const isAiContext =
      !isQueryMode && !!this.aiSearchService.lastGeneratedQueryData;
    const dialogData = authQuery
      ? {
          uid: isQueryMode ? authQuery.uid : undefined,
          name: authQuery.name,
          description: authQuery.description ?? '',
          query: authQuery.query,
          groups: authQuery.groups ?? [],
          _isAiGenerated: isSearchMode || isAiContext || undefined,
        }
      : this.aiSearchService.lastGeneratedQueryData;

    this.dialog.open(QueryEditorComponent, { data: dialogData });
  }

  onSave(action: string): void {
    this.dialog.open(QueryNameComponent, {
      data: {
        action,
        query: this.titolo?.entity,
      },
    });
  }
}
